import React from 'react'
import { NavEventArgs } from 'common/events/nav-event-types'
import { Section } from 'component-library/__styling/settings/sections'
import { StyledLink, StyledList, StyledListItem } from './FlyoutSubnav.styled'
import { KeyCode } from 'component-library/__helpers/key-code'
import { NavItem } from 'common/navigation'

export interface Props {
    navItems: NavItem[]
    section: Section
    onClick?: (args: NavEventArgs) => void
    onToggle?: () => void
    id: string
}

export const FlyoutSubnav: React.FC<Props> = ({ navItems, onClick, id, onToggle = () => {} }) => {
    const keyDownHandler = (evt: React.KeyboardEvent) => {
        if (evt.which === KeyCode.ESCAP) {
            evt.stopPropagation()
            onToggle()
        }
    }

    return (
        <StyledList id={id} role="menu" onKeyDown={keyDownHandler}>
            {navItems.map((navItem, index) => (
                <StyledListItem key={navItem.name} role="menuitem">
                    <StyledLink
                        children={navItem.name}
                        openExternalInNewWindow={navItem.newWindow}
                        target={navItem.newWindow ? '_blank' : undefined}
                        rel={navItem.newWindow ? 'noopener' : undefined}
                        to={navItem.link}
                        onClick={() => {
                            onClick &&
                                onClick({
                                    navPos: index,
                                    navText: navItem.name,
                                    navLink: navItem.link,
                                    navParent: parent.name,
                                })
                        }}
                    />
                </StyledListItem>
            ))}
        </StyledList>
    )
}
